import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    CanMatch,
    Route,
    Router,
    RouterStateSnapshot,
    UrlSegment,
    UrlTree
} from "@angular/router";
import { NzNotificationService } from "ng-zorro-antd/notification";

import { LoginService } from "../services/login.service";

@Injectable({ providedIn: "root" })
export class MerchantsAccessGuard implements CanActivate, CanActivateChild, CanMatch {
    constructor(
        private readonly loginService: LoginService,
        private readonly router: Router,
        private readonly notification: NzNotificationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        return this.evaluate();
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        return this.evaluate();
    }

    canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree {
        // Only the exact assignment child route may reach its own fresh capability guard.
        const offset = segments[0]?.path === "merchants" ? 1 : 0;
        if (segments.length === offset + 3 && segments[offset]?.path === "assign_users") return true;
        return this.evaluate();
    }

    private evaluate(): boolean | UrlTree {
        if (this.loginService.hasAdminPrivileges()) {
            return true;
        }

        this.notification.warning("Access denied", "You don't have access to the requested page.");
        return this.router.parseUrl("/dashboard/home");
    }
}
